













































































































import {
  GLAccount,
  IDepartment,
  IGLAccount,
  IPaymentRequisitionLine,
  IPaymentRequisitionLineFieldError,
  PaymentRequisitionLineFieldError
} from '@/models';
import { defaultFilter, getObjectValueByPath } from '@/utils/helpers';
import Vue, { PropType } from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'PaymentRequisitionDetailFormLineCard',

  props: {
    lineNum: {
      type: Number,
      required: true
    },

    line: {
      type: Object as PropType<IPaymentRequisitionLine>,
      required: true
    },

    departments: {
      type: Array as () => IDepartment[],
      required: true
    },

    accounts: {
      type: Array as () => IGLAccount[],
      required: true
    },

    fieldError: {
      type: Object as PropType<IPaymentRequisitionLineFieldError>,
      default: () => new PaymentRequisitionLineFieldError()
    }
  },

  data: () => ({
    rules: [(v: string) => v.length <= 2000 || 'Max 2000 characters']
  }),

  computed: {
    ...mapGetters({
      getGLAccountsByDepartment: 'accounting/getGLAccountsByDepartment'
    }),

    filteredAccounts(): GLAccount[] {
      if (this.line.department) {
        const department =
          typeof this.line.department === 'number'
            ? this.line.department
            : this.line.department.id;
        return this.getGLAccountsByDepartment(department);
      }

      return this.accounts;
    }
  },

  methods: {
    deleteLine() {
      this.$emit('delete:line', this.lineNum);
    },

    clearAccountValidation() {
      this.clearErrors();
      this.fieldError.account?.splice(0, this.fieldError.account?.length);
    },

    clearAccountIfNotValid() {
      this.clearAccountValidation();

      if (!this.line.account) return;
      this.line.account = null;
    },

    filter: (item: any, queryText: string): boolean => {
      const filterList = ['code', 'name', 'code-name', 'codename', 'code_name'];
      // added proxy filter and value keys to filter by
      item['code-name'] = `${item.code} - ${item.name}`;
      item['codename'] = `${item.code}${item.name}`;
      item['code_name'] = `${item.code} ${item.name}`;
      return filterList.some(key =>
        defaultFilter(getObjectValueByPath(item, key), queryText, item)
      );
    },

    clearErrors() {
      this.fieldError.clearErrors();
      this.$emit('clearErrors');
    }
  }
});
